import PropTypes from 'prop-types';
import Spinner from '../../assets/styles/spinner';
import defaultLoadingVideo from '../../assets/video/loading-loop.gif';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function Loader({
  isLoading,
  minimal = false,
  size = 120,
  videoSrc = defaultLoadingVideo,
}) {
  if (!isLoading) {
    return null;
  }

  if (minimal)
    return (
      <styles.Div>
        <Spinner size={size === 120 ? 80 : size} videoSrc={videoSrc} />
      </styles.Div>
    );

  return (
    <ReactPortal containerId="loader">
      <styles.Overlay>
        <Spinner size={size} videoSrc={videoSrc} />
      </styles.Overlay>
    </ReactPortal>
  );
}

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  minimal: PropTypes.bool,
  size: PropTypes.number,
  videoSrc: PropTypes.string,
};
